import { Button } from '../ui';
import type { AcousticCalibrationTag } from '../../lib/acoustic/calibrationTypes';
import { ACOUSTIC_CALIBRATION_TAGS } from '../../lib/acoustic/calibrationTypes';

const TAG_VARIANTS: Record<AcousticCalibrationTag, 'primary' | 'outline' | 'ghost'> = {
  single_speaker: 'outline',
  conversation: 'outline',
  babble: 'outline',
  shouting: 'outline',
  silence: 'outline'
};

type AcousticCalibrationTagPanelProps = {
  counts: Record<AcousticCalibrationTag, number>;
  disabled?: boolean;
  onTag: (tag: AcousticCalibrationTag) => void;
};

export default function AcousticCalibrationTagPanel({
  counts,
  disabled,
  onTag
}: AcousticCalibrationTagPanelProps) {
  return (
    <div className="grid gap-2 sm:grid-cols-2">
      {ACOUSTIC_CALIBRATION_TAGS.map((entry) => (
        <Button
          key={entry.key}
          type="button"
          variant={TAG_VARIANTS[entry.key]}
          disabled={disabled}
          className="h-auto flex-col items-start gap-1 px-3 py-3 text-left"
          onClick={() => onTag(entry.key)}
        >
          <span className="font-semibold">
            {entry.label}
            {counts[entry.key] > 0 ? (
              <span className="ml-2 text-xs font-normal text-gray-500 dark:text-gray-400">
                ({counts[entry.key]})
              </span>
            ) : null}
          </span>
          <span className="text-xs font-normal text-gray-500 dark:text-gray-400">{entry.description}</span>
        </Button>
      ))}
    </div>
  );
}
